import React from 'react';

import SuppliersIndex from '../../suppliers/SuppliersIndex';
import { useProcurement } from '../context/ProcurementContext';

const ProcurementContractManagementSuppliersTab = () => {
    const { settings, routes } = useProcurement();

    return (
        <SuppliersIndex
            integrationConfigured={settings.isIntegrationConfigured}
            syncEnabled={settings.isSyncEnabled}
            action={settings.processedActionSyncSuppliers}
            model={settings.processedModelSupplier}
            toggleUrl={routes.toggleSyncErpUrl}
            syncNowUrl={routes.syncErpNowUrl}
        />
    );
};

export default ProcurementContractManagementSuppliersTab;
